import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Dropdown, Menu, Spin } from 'antd';
import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import styles from './index.module.less';
import avatarPng from '@/shared/assets/png/avatar.png';
import { Thing } from '@/shared/components/Auth/Thing';
import { useLocation } from 'react-router-dom';
import { UIMS_BASE } from '@/shared/utils';
import { useSharedGlobalState } from '@/shared/hooks';
const HeaderDropdown = ({ overlayClassName: cls, placement, showMenu, noBase, ...restProps }) => {
    const [spinning, setSpinning] = useState(false);
    const { orgMyUserInfoType: userInfo, _initStateByKey } = useSharedGlobalState();
    const { authLoginType: REACT_APP_SYS } = useSharedGlobalState();
    const location = useLocation();
    const onMenuClick = useCallback((event) => {
        const { key } = event;
        if (key === 'logout') {
            if (window.location.pathname !== '/user/login') {
                Thing().logout();
            }
            return;
        }
        else {
            // /account    /uims/account
            window.location.href = `${noBase ? `/${window.location.pathname?.split?.('/')?.[1]}` : UIMS_BASE}/account`;
        }
    }, []);
    const menuHeaderDropdown = (_jsxs(Menu, { className: styles.menu, selectedKeys: [], onClick: onMenuClick, children: [showMenu === false ? ('') : (REACT_APP_SYS != 'GOV' && _jsxs(React.Fragment, { children: [_jsxs(Menu.Item, { children: [_jsx(UserOutlined, { style: { marginRight: '4px' } }), "\u8D26\u6237\u4E2D\u5FC3"] }, "account"), _jsx(Menu.Divider, {})] })), _jsxs(Menu.Item, { children: [_jsx(LogoutOutlined, { style: { marginRight: '4px' } }), "\u9000\u51FA\u767B\u5F55"] }, "logout")] }));
    if (!userInfo) {
        return null;
    }
    return (_jsx(Dropdown, { overlayClassName: classNames(styles.container, cls), placement: placement, ...restProps, 
        // @ts-ignore
        overlay: menuHeaderDropdown, children: _jsx(Spin, { spinning: spinning, children: _jsxs("div", { className: styles.avatar, children: [_jsx(Avatar, { size: 32, src: userInfo?.picture?.fileSrcUrl ?? avatarPng, alt: "avatar" }), _jsx("span", { style: {
                            marginLeft: '4px',
                            lineHeight: '32px',
                            color: '#ffffff',
                            cursor: 'pointer',
                            display: 'inline-block',
                            overflow: 'hidden',
                            maxWidth: '120px',
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis"
                        }, className: "grid-header-mobile", children: Number(userInfo?.certificationStatus) === 3
                            ? `${userInfo.name}${userInfo.nickName ? `(${userInfo.nickName})` : null}`
                            : userInfo.nickName ?? '' })] }) }) }));
};
export default HeaderDropdown;
